import { render, staticRenderFns } from "./InformacoesSaidaPaciente.vue?vue&type=template&id=63d94844&"
import script from "./InformacoesSaidaPaciente.vue?vue&type=script&lang=js&"
export * from "./InformacoesSaidaPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports